module.exports = __webpack_public_path__ + "img/bali-wave.2b752936.jpg";